export default function ScaleOnLoad() {
    return {
        link: function(scope, element) {
            //rescaling the images to fit the carousel after load
            element.bind('load', function() {
                element[0].style.height = '100%';
            });
            scope.$on('$destroy', () => element.off('load'));
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/scale-on-load-directive.js